
        <td colspan="100%">
            <collapsible-list-item>
                <collapsible-body>
                    <ng-content></ng-content>
                </collapsible-body>
            </collapsible-list-item>
        </td>
    


// WEBPACK FOOTER //
// ./node_modules/angular2-collapsible/angular2-collapsible.d.ts.CollapsibleTableRowDetailComponent.html